import React from "react";

function SvgIcMapPoi008(props) {
  return (
    <svg width="1em" height="1em" viewBox="0 0 32 32" {...props}>
      <g fill="none" fillRule="evenodd">
        <path
          d="M23.5 18a1.498 1.498 0 01-1.5-1.5 1.499 1.499 0 113 0 1.5 1.5 0 01-1.5 1.5zM9.754 12c-.277 0-.43-.212-.342-.473l1.103-3.313c.212-.635.606-1.014 1.684-1.014h7.6c1.03 0 1.472.378 1.684 1.014l1.104 3.313c.087.26-.065.474-.343.474H9.755zm9.745 7h-7a.5.5 0 010-1h7a.5.5 0 110 1zm-11-1A1.503 1.503 0 017 16.5 1.5 1.5 0 118.5 18zM25 13l-.648-.646a2.497 2.497 0 01-.509-.827l-1.21-3.63c-.35-1.047-1.329-1.896-2.433-1.896L11.8 6c-1.104.002-2.083.849-2.433 1.897l-1.208 3.629a2.523 2.523 0 01-.511.828L7.002 13C6.448 13.554 6 14.897 6 16v5l.003 1.001A.995.995 0 007 23h2c.553 0 1-.448 1-1v-1h12v1a1.002 1.002 0 001 1h2a1.002 1.002 0 001-1l-.001-6c.001-1.103-.446-2.446-1-3z"
          fill="#FFF"
        />
      </g>
    </svg>
  );
}

export default SvgIcMapPoi008;
